const RTL_THRESHOLD = 0.6;
const RTL_REGEX = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/g;
const LTR_REGEX =
    /[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0370-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE10-\uFE6F\uFEFD-\uFFFF]/g;

/**
 * Determines if text is right to left by counting strong directional characters.
 * Uses a 60% threshold to handle mixed content (e.g. Hebrew text with English brand names or URLs).
 * Returns false for neutral-only text (numbers, punctuation, whitespace).
 */
export const isRTL = (text: string): boolean => {
    const rtlCount = (text.match(RTL_REGEX) || []).length;
    const ltrCount = (text.match(LTR_REGEX) || []).length;
    const total = rtlCount + ltrCount;

    if (total === 0) {
        return false;
    }

    return rtlCount / total > RTL_THRESHOLD;
};
